import React from "react";
import { useState } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";
import { Translate } from "../../../Enums/Tranlate";
import MatchesService from "../../../../services/MatchesService";
import { useNavigate } from "react-router-dom";
import Public from "./Public";
import Tournaments from "./Tournaments";
import Private from "./Private";

const Matches = () => {
	const tabs = ["public_matches", "private_matches", "tournaments"];
	const [selectTab, setSelectTab] = useState(tabs[0]);
	const [data, setData] = useState([]);
	const [hasData, setHasData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const matchesService = new MatchesService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const search = useSelector((state) => state.auth.search);
	const navigate = useNavigate();

	return (
		<div className="department">
			<div className="mb-4">
				<div className="search-card d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang][selectTab]}
						</span>
					</div>
					<div className="add-admin">
						{isExist("add_matches") && (
							<Button
								variant="primary"
								className="me-2 h-75"
								onClick={() => navigate("/matches/add-matches")}>
								<i
									className={`la la-plus ${
										lang === "en" ? "mr-2" : "ml-2"
									}`}></i>
								{Translate[lang]?.add} {Translate[lang].match}
							</Button>
						)}
					</div>
				</div>
			</div>
			<div className="tabs-div mb-4">
				{tabs?.map((tab, index) => {
					return (
						<p
							key={index}
							className={`${tab === selectTab ? "activeP" : ""}`}
							onClick={() => {
								setSelectTab(tab);
								setShouldUpdate((prev) => !prev);
							}}>
							{Translate[lang][tab]}
						</p>
					);
				})}
			</div>
			<Row>
				<Col lg={12}>
					<Card>
						<div
							className={`${hasData === 0 ? "text-center" : "table-style"} `}>
							{loading && (
								<div style={{ height: "400px" }}>
									<Loader />
								</div>
							)}

							{hasData === 1 && !loading && (
								<>
									{selectTab === tabs[0] && (
										<Public data={data} setShouldUpdate={setShouldUpdate} />
									)}
									{selectTab === tabs[1] && (
										<Private data={data} setShouldUpdate={setShouldUpdate} />
									)}
									{selectTab === tabs[2] && (
										<Tournaments
											data={data}
											setShouldUpdate={setShouldUpdate}
										/>
									)}
								</>
							)}
							{hasData === 0 && <NoData />}
							<Pagination
								setData={setData}
								service={matchesService}
								shouldUpdate={shouldUpdate}
								setHasData={setHasData}
								urlType={
									selectTab === "public_matches"
										? "public"
										: selectTab === "private_matches"
										? "private"
										: "tournament"
								}
								setLoading={setLoading}
								search={search}
							/>
						</div>
					</Card>
				</Col>
			</Row>
		</div>
	);
};

export default Matches;
